import React, { useEffect } from "react";

import { css } from "@emotion/react";
import { PlainTechSpecSection } from "@swo/storefront";
import { FONTS, fontSize } from "../../../styles/fonts";
import { T } from "../../../components/T";

export function PlainSection(props: PlainTechSpecSection) {
  return (
    <div>
      {props.attributes.map(attribute => {
        return (
          <div
            key={attribute.__key}
            css={css`
              display: flex;
              flex-direction: column;
              align-items: center;

              margin: 10px 0;
            `}
          >
            <span css={[FONTS.SwarovskiFutura500, fontSize.x3]}>
              <T>{attribute.label}</T>
            </span>
          </div>
        );
      })}
    </div>
  );
}
